"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indent = exports.bin = exports.con = exports.line = void 0;
const toLine_1 = require("pojo-dump/lib/toLine");
const json_crdt_patch_1 = require("../json-crdt-patch");
exports.line = toLine_1.toLine;
const con = (value) => {
    const formatted = value instanceof Uint8Array
        ? 'Uint8Array ' + (0, exports.bin)(value)
        : `{ ${value instanceof json_crdt_patch_1.Timestamp ? (0, json_crdt_patch_1.printTs)(value) : (0, exports.line)(value)} }`;
    return formatted;
};
exports.con = con;
const bin = (value) => '{ ' + ('' + value).replaceAll(',', ', ') + ' }';
exports.bin = bin;
const indent = (tab, pojo) => String(JSON.stringify(pojo, null, 2)).replace(/\n/g, '\n' + tab);
exports.indent = indent;
